// Static, shared short links to the Tread driver mobile app and its onboarding
// resources. These are non-personalized links that already exist — per-driver
// tracked invite links are out of scope for TRE-15787 and would require backend
// work.
export const DRIVER_APP_LINK = 'https://link.tread.io/app';
export const DRIVER_TRAINING_VIDEO = 'https://link.tread.io/vid';
export const DRIVER_QUICK_START = 'https://link.tread.io/driver-quick-start';
export const DRIVER_FULL_TRAINING = 'https://link.tread.io/driver-training';
